import React from 'react';

import { IBdsLabelPill } from '../../../interfaces/bdsLabelPill';

import './BdsLabelPill.scss';

const BdsLabelPill = ({ text, variant, color, iconLeft, iconRight, className, bold = true }: IBdsLabelPill) => {
  const classNames = ['bds-label-pill', variant, color, className].join(' ');

  const renderContent = () => {
    return (
      <>
        {iconLeft && <iconLeft.component className="bds-label-pill-icon" />}
        <div className={`bds-label-pill ${bold ? 'bold' : ''}`}>{text}</div>
        {iconRight && <iconRight.component className="bds-label-pill-icon" />}
      </>
    );
  };

  return <span className={classNames}>{renderContent()}</span>;
};

export default BdsLabelPill;
